import {Context, Action} from './types'

export function joinEventName(
  context: Context,
  action: Action,
  description: string
): string {
  return `${context}: ${action} ${description}`.trim()
}
